import { call, put } from 'redux-saga/effects'
import { GET_STOCK_PRODUCTS_RESPONSE, GET_STOCK_PRODUCTS_ERROR } from '../actions/actionCreator'
import { getStockProductsAPI } from '../api'
// eslint-disable-next-line
export function * stockProductsSaga () {
  try {
    yield put(GET_STOCK_PRODUCTS_RESPONSE({ request: true }))
    const data = yield call(getStockProductsAPI)
    yield put(GET_STOCK_PRODUCTS_RESPONSE({ request: false, data: data, error: false }))
  } catch (error) {
    yield put(GET_STOCK_PRODUCTS_ERROR({ request: true, error: error }))
  }
}
